export const getCheckedNodes = (childNodes) => {
  let checked = [];
  Array.from(childNodes).forEach((node) => {
    if (node.checked) {
      checked = [...checked, node.value];
    }

    if (node.children != null) {
      checked = [...checked, ...getCheckedNodes(node.children)];
    }
  });

  return checked;
};

export const expandNodesToLevel = (childNodes, targetLevel, currentLevel = 0) => {
  if (currentLevel > targetLevel) {
    return [];
  }

  let expanded = [];
  Array.from(childNodes).forEach((node) => {
    if (node.children) {
      expanded = [...expanded, node.value, ...expandNodesToLevel(node.children, targetLevel, currentLevel + 1)];
    }
  });

  return expanded;
};
